export const setHover = (hover) => {
    return {
        type: 'SET_HOVER',
        hover,
    }
}

export default {
    setHover
}